import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/supplier/styles/index.css';
//notice: index.css must be imported before App.tsx to enable style overrides
import App from '@link/supplier/App';
import { StoreProvider, store } from '@link/supplier/stores';
import '@link/supplier/i18n';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
